export default [
    {
        id: 1,
        question: 'کیفیت محصولات تبرک',
        score: ''
    },
    {
        id: 2,
        question: 'قیمت محصولات',
        score: ''
    },
    {
        id: 3,
        question: 'بسته بندی محصولات',
        score: ''
    },
    {
        id: 4,
        question: 'تنوع سبد کالایی',
        score: ''
    },
    {
        id: 5,
        question: 'در دسترس بودن محصولات',
        score: ''
    },
    {
        id: 6,
        question: 'تبلیغات تبرک (رسانه های جمعی، مجازی، بیلبورد)',
        score: ''
    },
    {
        id: 7,
        question: 'وجود تخفیفات و آفرها و جوایز فروش',
        score: ''
    },
    {
        id: 8,
        question: 'مدت زمان تورهای ویزیت',
        score: ''
    },
    {
        id: 9,
        question: 'مدت زمان توزیع',
        score: ''
    },
    {
        id: 10,
        question: 'نحوه توزیع',
        score: ''
    },
    {
        id: 11,
        question: 'شرایط پرداخت',
        score: '',
        options: [
            'نقد',
            'مطالبات',
            'چک',
        ]
    },
    {
        id: 12,
        question: 'مدت زمان دریافت چک های پرداختی ',
        score: '',
        options: [
            'نقدی',
            '20 روزه',
            '30 روزه',
            '45 روزه',
            '60 روزه',
        ]
    },
    {
        id: 13,
        question: 'نحوه برخورد تیم نمایندگی تبرک (ویزیتور، موزع)',
        score: ''
    }

]